/**
* Ensures that a date is set to UTC time.
* We do this so the date we send to the Yumbi API is not altered.
*/
Date.prototype.toUTCString = function() {
    return moment(this).format('YYYY-MM-DD HH:mm');
};